import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { getIssueTypeList, getIssueTypeById, issueTypeAdd, issueTypeAddInstant, issueTypeUpdate, issueTypeDelete } from  '../../helpers/';
import { issueTypeApiResponseSuccess, issueTypeApiResponseError } from "./actions";
import { IssueTypeActionTypes } from "./constants";

/**
 * 
 * Get List Issue Type
 * @param {*} payload
 * @query - page, [ issue_type_id, issue_type_name, issue_type_description ]
 * 
 */

function* issueTypeList({ payload }) {
    try {
        const response = yield call(getIssueTypeList, payload.params);
        yield put(issueTypeApiResponseSuccess(IssueTypeActionTypes.GET_ISSUE_TYPE_LIST, response.data));
    } catch(error) {
        yield put(issueTypeApiResponseError(IssueTypeActionTypes.GET_ISSUE_TYPE_LIST, error));
    }
};

function* issueTypeById({ payload }) {
    try {
        const response = yield call(getIssueTypeById, payload);
        yield put(issueTypeApiResponseSuccess(IssueTypeActionTypes.GET_ISSUE_TYPE_ID, response.data))
    } catch(error) {
        yield put(issueTypeApiResponseError(IssueTypeActionTypes.GET_ISSUE_TYPE_ID, error));
    }
};

function* issueTypeCreate({ payload }) {
    try {
        const response = yield call(issueTypeAdd, payload);
        yield put(issueTypeApiResponseSuccess(IssueTypeActionTypes.ADD_ISSUE_TYPE, response.data));
    } catch(error) {
        yield put(issueTypeApiResponseError(IssueTypeActionTypes.ADD_ISSUE_TYPE, error));
    }
};

function* issueTypeCreateInstant({ payload }) {
    try {
        const response = yield call(issueTypeAddInstant, payload);
        yield put(issueTypeApiResponseSuccess(IssueTypeActionTypes.ADD_ISSUE_TYPE_INSTANT, response.data));
    } catch(error) {
        yield put(issueTypeApiResponseError(IssueTypeActionTypes.ADD_ISSUE_TYPE_INSTANT, error));
    }
};

function* issueTypePut({ payload }) {
    try {
        const response = yield call(issueTypeUpdate, payload);
        yield put(issueTypeApiResponseSuccess(IssueTypeActionTypes.UPDATE_ISSUE_TYPE, response.data));
    } catch(error) {
        yield put(issueTypeApiResponseError(IssueTypeActionTypes.UPDATE_ISSUE_TYPE, error));
    }
}

function* issueTypeDel({ payload }) {
    try {
        const response = yield call(issueTypeDelete, payload);
        yield put(issueTypeApiResponseSuccess(IssueTypeActionTypes.DELETE_ISSUE_TYPE, response.data))
    } catch(error) {
        yield put(issueTypeApiResponseError(IssueTypeActionTypes.DELETE_ISSUE_TYPE, error));
    }
}

export function* watchIssueTypeList() {
    yield takeEvery(IssueTypeActionTypes.GET_ISSUE_TYPE_LIST, issueTypeList)
}

export function* watchIssueTypeById() {
    yield takeEvery(IssueTypeActionTypes.GET_ISSUE_TYPE_ID, issueTypeById);
}

export function* watchIssueTypeAdd() {
    yield takeEvery(IssueTypeActionTypes.ADD_ISSUE_TYPE, issueTypeCreate);
}

export function* watchIssueTypeAddInstant() {
    yield takeEvery(IssueTypeActionTypes.ADD_ISSUE_TYPE_INSTANT, issueTypeCreateInstant)
}

export function* watchIssueTypeUpdate() {
    yield takeEvery(IssueTypeActionTypes.UPDATE_ISSUE_TYPE, issueTypePut);
}

export function* watchIssueTypeDelete() {
    yield takeEvery(IssueTypeActionTypes.DELETE_ISSUE_TYPE, issueTypeDel);
}

function* issueTypeSaga() {
    yield all([
        fork(watchIssueTypeList),
        fork(watchIssueTypeById),
        fork(watchIssueTypeAdd),
        fork(watchIssueTypeAddInstant),
        fork(watchIssueTypeUpdate),
        fork(watchIssueTypeDelete)
    ])
}

export default issueTypeSaga;